import { render, staticRenderFns } from "./MyPerformance.vue?vue&type=template&id=6d08d324&scoped=true"
import script from "./MyPerformance.vue?vue&type=script&lang=js"
export * from "./MyPerformance.vue?vue&type=script&lang=js"
import style0 from "./MyPerformance.vue?vue&type=style&index=0&id=6d08d324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08d324",
  null
  
)

export default component.exports